import { getProp } from "./getProp";

export function sumFilter(angebote, filter, column) {
  return (
    "(" +
    angebote.filter((angebot) => getProp(angebot, column) === filter).length +
    ")"
  );
}
